import React from 'react';

const steps = [
    {
        number: '01',
        title: 'Add your clients',
        description:
            'Create profiles for individuals or businesses. Attach contacts to business accounts and store all the details you need.',
    },
    {
        number: '02',
        title: 'Log interactions & set follow-ups',
        description:
            `Record every call, meeting, or email with notes and file attachments. Schedule a follow-up in seconds and see reminders on your dashboard when it's time to reach out.`,
    },
    {
        number: '03',
        title: 'Stay on top of everything',
        description:
            'Your calendar shows past and upcoming interactions and follow-ups at a glance. Use AI summaries to quickly catch up on any client before a meeting.',
    },
];

const HowItWorks: React.FC = () => {
    return (
        <section id="how-it-works" className="bg-gray-50 py-20 px-4">
            <div className="max-w-5xl mx-auto">
                <div className="text-center mb-14">
                    <h2 className="text-3xl font-bold text-crumbblue mb-3">How it works</h2>
                    <p className="text-gray-500 max-w-xl mx-auto">
                        CrumbCRM is designed to fit into the way you already work — not the other way around.
                    </p>
                </div>

                <div className="relative">
                    {/* vertical connector line on md+ */}
                    <div className="hidden md:block absolute left-[2.6rem] top-10 bottom-10 w-px bg-blue-100" />

                    <div className="flex flex-col gap-10">
                        {steps.map((step) => (
                            <div key={step.number} className="flex items-start gap-6">
                                {/* step number badge */}
                                <div className="flex-shrink-0 w-20 h-20 rounded-2xl bg-crumbblue text-white flex flex-col items-center justify-center shadow-sm">
                                    <span className="text-[10px] font-semibold tracking-widest uppercase text-blue-200">Step</span>
                                    <span className="text-2xl font-extrabold leading-none">{step.number}</span>
                                </div>

                                <div className="pt-2">
                                    <h3 className="text-lg font-bold text-gray-800 mb-1">{step.title}</h3>
                                    <p className="text-gray-500 text-sm leading-relaxed max-w-xl">{step.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;